import { render } from "./SidePanelHeader.vue?vue&type=template&id=1e9b210e&ts=true"
import script from "./SidePanelHeader.vue?vue&type=script&lang=ts"
export * from "./SidePanelHeader.vue?vue&type=script&lang=ts"

import "./SidePanelHeader.vue?vue&type=style&index=0&id=1e9b210e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__